import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getGalleryApi } from '../api/allApi';

export const fetchGallery = createAsyncThunk(
    'gallery/fetchGallery',
    async (_, { rejectWithValue }) => {
        try {
            return await getGalleryApi();
        } catch (err) {
            return rejectWithValue(err?.response?.data?.message || 'Failed to fetch gallery');
        }
    }
);

const gallerySlice = createSlice({
    name: 'gallery',
    initialState: { data: null, fetchLoading: false, error: null },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchGallery.pending, (state) => {
                state.fetchLoading = true;
                state.error = null;
            })
            .addCase(fetchGallery.fulfilled, (state, action) => {
                state.fetchLoading = false;
                state.data = action.payload;
            })
            .addCase(fetchGallery.rejected, (state, action) => {
                state.fetchLoading = false;
                state.error = action.payload;
            });
    },
});

export default gallerySlice.reducer;